import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationHub from '../components/NotificationHub';
import GradientButton from '../components/GradientButton';
import { API_BASE_URL } from '../config/api';
import './css/Register.css';

const Register = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const navigate = useNavigate();

  const handleNotificationDismiss = (id) => {
    setNotifications((prev) => prev.filter((notification) => notification.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!termsAccepted) {
      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), msgText: '请先同意用户协议和隐私政策' },
      ]);
      return;
    }

    if (password !== confirmPassword) {
      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), msgText: '请确保两次密码输入一致' },
      ]);
      return;
    }

    try {
      // First, get a CSRF token
      const csrfResponse = await fetch(`${API_BASE_URL}/register/`, {
        method: 'GET',
        credentials: 'include', // Include cookies in the request
      });
      
      // Get the CSRF token from cookies
      const getCsrfToken = () => {
        const name = 'csrftoken=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        
        for (let i = 0; i < cookieArray.length; i++) {
          let cookie = cookieArray[i].trim();
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
          }
        }
        return '';
      };
      
      const csrfToken = getCsrfToken();
      
      // Now make the registration request with the CSRF token
      const response = await fetch(`${API_BASE_URL}/register/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify({ username, email, password }),
        credentials: 'include', // Include cookies in the request
      });

      const data = await response.json();

      if (response.ok) {
        // Store username and userid in localStorage, token is in HTTP-only cookie
        localStorage.setItem('username', data.username);
        localStorage.setItem('userid', data.userid);

        // Dispatch loginStatusChanged event
        window.dispatchEvent(new Event('loginStatusChanged'));

        setNotifications((prev) => [
          ...prev,
          { id: Date.now(), msgText: data.message || 'Registration successful' },
        ]);

        // Redirect to homepage after a short delay
        setTimeout(() => {
          navigate('/');
        }, 1500);
      } else {
        setNotifications((prev) => [
          ...prev,
          { id: Date.now(), msgText: data.error || 'Registration failed' },
        ]);
      }
    } catch (error) {
      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), msgText: 'An error occurred during registration' },
      ]);
    }
  };

  const termsContent = (
    <div className="terms-modal" style={{
      display: showTerms ? 'block' : 'none',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      maxWidth: '80%',
      maxHeight: '80vh',
      overflow: 'auto',
      zIndex: 1000
    }}>


      <h2>网站条款与条件</h2>
      <p>欢迎访问猫咪（Maomi）网站。请仔细阅读以下条款与条件，一旦您使用我们的网站，即表示您同意并接受以下所有条款。</p>
      <p>1. 服务说明</p>
      <p>猫咪网站（以下称为“本网站”）提供宠物商品展示、销售以及相关信息服务。本网站所有内容仅供用户参考和个人使用。</p>
      <p>2. 用户注册</p>
      <p>在注册时，您需提供准确、完整的信息，并确保信息的真实有效性。用户有义务妥善保管账户信息，不得将账户转让或借予他人使用。</p>
      <p>3. 用户行为规范</p>
      <p>使用本网站时，您同意遵守所有适用的法律法规。您不得在本网站上传、发布或传播任何违法、侵权、虚假、不雅、威胁、骚扰的内容。</p>
      <p>4. 隐私政策</p>
      <p>我们非常重视用户的隐私保护。您提供的所有个人信息都将依据我们的隐私政策进行处理。请参阅隐私政策了解详细内容。</p>
      <p>5. 商品信息</p>
      <p>本网站尽量确保商品信息的准确性。然而，由于市场变化或其他因素，可能导致部分信息（如价格、库存）在未提前通知的情况下有所更改。本网站保留随时更改信息的权利。</p>
      <p>6. 订单</p>
      <p>当您在本网站下订单时，即表示您希望购买所选商品。我们将尽最大努力处理您的订单，但不保证所有商品都能提供。如无法处理订单或出现错误，我们保留取消或拒绝订单的权利。</p>
      <p>7. 知识产权</p>
      <p>本网站的所有内容（包括文字、图片、视频、商标等）均受著作权、商标权及其他相关法律保护。未经书面许可，任何人不得复制、使用或修改本网站的内容。</p>
      <p>8. 责任限制</p>
      <p>本网站不对因不可控因素（如自然灾害、网络故障、黑客攻击等）导致的服务中断、延迟或错误负责。对于因使用或无法使用本网站造成的任何损失，本网站不承担任何责任。</p>
      <p>9. 条款修改</p>
      <p>本网站有权随时更新或修改本条款内容，修改后的条款自发布之日起生效。请定期查看条款以了解最新内容。</p>
      <p>10. 适用法律与管辖</p>
      <p>本条款适用中华人民共和国法律，任何争议应提交至本网站所在地的法院进行处理。</p>
      <p>感谢您对猫咪网站的信任与支持！如有任何问题，请联系我们的客服团队。</p>
      <GradientButton 
        onClick={() => setShowTerms(false)}
        className="btn btn-primary"
        style={{ marginTop: '10px' }}
      >
        关闭
      </GradientButton>
    </div>
  );

  return (
    <div className="register-container">
      <div className="logreg-container mt-5 p-4 bg-white shadow rounded">
        <h2 className="text-center mb-4">用户注册</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">用户名</label>
            <input
              type="text"
              className="form-control"
              id="username"
              name="username"
              placeholder="用户名"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email（选填）</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="邮箱地址"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">密码</label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              placeholder="输入密码"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">确认密码</label>
            <input
              type="password"
              className="form-control"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="请确认密码"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="register-form-group">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="terms"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="terms">
                我已阅读并同意
                <span 
                  onClick={() => setShowTerms(true)}
                  style={{ 
                    color: '#007bff', 
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    marginLeft: '4px'
                  }}
                >
                  用户协议和隐私政策
                </span>
              </label>
            </div>
          </div>
          <button type="submit" className="btn btn-block logreg-submit">注册</button>
        </form>
      </div>
      {showTerms && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#fdfef8',
            zIndex: 999
          }}
          onClick={() => setShowTerms(false)}
        />
      )}
      {termsContent}
      <NotificationHub notifications={notifications} onNotificationDismiss={handleNotificationDismiss} />
    </div>
  );
}

export default Register;
